<template>
  <div class="content-wrap">
    <p>Блок в котором вы сейчас читаете этот текст называется <span class="text-accent green">виджет</span>.</p>
    <p>Пространство страницы на котором такие блоки расположены это <span class="text-accent blue">дашборд</span>.</p>

    <p class="text-h6 text-center">Дашборд</p>
    <p>* Дашборд состоит из виджетов. У дашборда есть два режима работы: режим просмотра и режим редактирования. Для переключения между режимами, нажмите правой клавишей мыши на свободном от виджетов пространстве дашборда и выберите соответствующий пункт меню.</p>
    <p>- В режиме просмотра положение виджетов жёстко зафиксирована.</p>
    <p>- В режиме редактирования можно добавлять новые виджеты, редактировать их настройки, менять положение и размер.</p>
    <hr>
    <p class="text-h6 text-center mt-7">Виджеты</p>
    <p>* Для добавления нового виджета нажмите правой клавишей на свободном от виджетов пространстве дашборда и в выпадающем меню выберите "Добавить виджет".</p>
    <p>* Виджеты отображают информацию согласно своим настройкам. Настройки виджетов не меняются автоматически. Например, если у вас в настройках виджета выбраны некоторые проекты, то новый проект который вам добавили в виджете не появится. Но, если в настройках виджета выбрана группа, то при добавлении нового сотрудника в группу в настройках виджета ничего менять не нужно, новый сотрудник попадёт в выдачу виджета автоматически, так как выдача идёт согласно выбранной в настройках группы.</p>
    <p>* Виджеты могут иметь несколько режимов просмотра. Например, графический и табличный. По умолчанию в режиме просмотра будет отображаться тот режим, который был активирован последним в режиме редактирования.</p>
    <p>* При нажатии на крестик в режиме редактирования виджет удаляется и все его настройки сбрасываются.</p>
    <p>* Вы можете создать любое количество виджетов одинакового типа, но с разными настройками которые будут отображать разные данные.</p>
    <p class="mt-12">Сохранение происходит при выходе из режима редактирования.</p>
  </div>
</template>


<script>

export default {
  name: 'HintWidget',
  props: {
    view: String,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
}
</script>


<style scoped lang="scss">
.content-wrap {
  padding: 1.5rem;
  height: 100%; 
  overflow-y: auto;
}
.text-accent {
	padding-inline: 0.2em;
	font-weight: bold;
}
</style>